/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { FieldListEditWrapper } from "cms/fields/field-lists/field-list-wrapper";
import EmbedFieldItemEdit from "./edit-item";

const EmbedFieldEdit = () => {
    
    return (
        <FieldListEditWrapper>
            <EmbedFieldItemEdit />
        </FieldListEditWrapper>
    );
};
EmbedFieldEdit.displayName = "EmbedFieldEdit";
export { EmbedFieldEdit };
